import { TOTAL, LATEST } from "./constants";
import formatTwoDigits from "./helpers/formatTwoDigits";
import createDateFromPeriod from "./helpers/createDateFromPeriod";
import createYearsArray from "./helpers/createYearsArray";
import createPeriods from "./helpers/createPeriods";

const filterPeriod = ({ period, fromYear, fromMonth, t }) => {
	const selected = createDateFromPeriod(`${period}`);

	const periods = createPeriods({
		selected,
		fromYear,
		fromMonth,
		t,
	});

	const years = createYearsArray({ fromYear, t });

	if (selected.year === null && selected.period === null) {
		Object.assign(selected, periods.normalizeByDate(selected.date));
	}

	return {
		selected,
		periods: periods.asFiltered(),
		years,
		asApiParam() {
			const { year, month, day } = this.selected.date;
			// Aby pobrać najnowsze treści należy podać month 0,  nie ma takiego miesiąca.
			if (this.selected.period === LATEST) {
				return {
					year: null,
					month: 0,
					day: null,
				};
			}
			return {
				year,
				month: month == null ? null : month + 1,
				day,
			};
		},
		toString() {
			if (this.selected.period === LATEST) {
				return this.selected.period;
			}
			if (
				this.selected.period === TOTAL ||
				this.selected.year === TOTAL
			) {
				return this.selected.year;
			}
			const { date } = this.selected;
			return [
				formatTwoDigits(date.day),
				formatTwoDigits(date.month, 1),
				date.year,
			]
				.filter((value) => value != null)
				.join("-");
		},
	};
};

export default filterPeriod;
